import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { PaymentChannelCodeEnum } from "@saleor/types/globalTypes";
import {
  createOptionsField,
  createTextField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum PaymentEventsFilterKeys {
  orderCode = "orderCode",
  transactionId = "transactionId",
  paymentMethodType = "paymentMethodType",
  reference = "reference"
}

export enum paymentChannelEnum {
  CARD = "CARD",
  GCASH = "GCASH",
  BPI = "ONLINEBANKING BPI",
  CHINABANK = "ONLINEBANKING CHINABANK",
  RCBC = "ONLINEBANKING RCBC",
  UBP = "ONLINEBANKING UBP",
  GRABPAY = "EWALLET GRABPAY",
  PAYMAYA = "EWALLET PAYMAYA"
}

export interface PaymentEventsListFilterOpts {
  orderCode: FilterOpts<string>;
  transactionId: FilterOpts<string>;
  paymentMethodType: FilterOpts<string>;
  reference: FilterOpts<string>;
  channelCode: FilterOpts<PaymentChannelCodeEnum | null>;
}

const messages = defineMessages({
  bpi: {
    defaultMessage: "Online Banking - BPI",
    description: "online banking bpi"
  },
  card: {
    defaultMessage: "CARD",
    description: "card"
  },
  chinabank: {
    defaultMessage: "Online Banking - CHINABANK",
    description: "online banking chinabank"
  },
  gcash: {
    defaultMessage: "GCASH",
    description: "cash"
  },
  grabpay: {
    defaultMessage: "E-Wallet - GRABPAY",
    description: "e-wallet grabpay"
  },
  orderCode: {
    defaultMessage: "Order Code",
    description: "order code"
  },
  paymaya: {
    defaultMessage: "E-Wallet - MAYA",
    description: "e-wallet paymaya"
  },
  paymentMethodType: {
    defaultMessage: "Payment Method",
    description: "payment method"
  },
  rcbc: {
    defaultMessage: "Online Banking - RCBC",
    description: "online banking rcbc"
  },
  reference: {
    defaultMessage: "Reference",
    description: "reference"
  },
  transactionId: {
    defaultMessage: "Transaction ID",
    description: "transaction id"
  },
  ubp: {
    defaultMessage: "Online Banking - UBP",
    description: "online banking ubp"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: PaymentEventsListFilterOpts
): IFilter<PaymentEventsFilterKeys> {
  return [
    {
      ...createTextField(
        PaymentEventsFilterKeys.orderCode,
        intl.formatMessage(messages.orderCode),
        opts.orderCode.value
      ),
      active: opts.orderCode.active
    },
    {
      ...createTextField(
        PaymentEventsFilterKeys.transactionId,
        intl.formatMessage(messages.transactionId),
        opts.transactionId.value
      ),
      active: opts.transactionId.active
    },
    {
      ...createOptionsField(
        PaymentEventsFilterKeys.paymentMethodType,
        intl.formatMessage(messages.paymentMethodType),
        [opts.paymentMethodType.value],
        false,
        [
          {
            label: intl.formatMessage(messages.card),
            value: paymentChannelEnum.CARD
          },
          {
            label: intl.formatMessage(messages.gcash),
            value: paymentChannelEnum.GCASH
          },
          {
            label: intl.formatMessage(messages.bpi),
            value: paymentChannelEnum.BPI
          },
          {
            label: intl.formatMessage(messages.chinabank),
            value: paymentChannelEnum.CHINABANK
          },
          {
            label: intl.formatMessage(messages.rcbc),
            value: paymentChannelEnum.RCBC
          },
          {
            label: intl.formatMessage(messages.ubp),
            value: paymentChannelEnum.UBP
          },
          {
            label: intl.formatMessage(messages.grabpay),
            value: paymentChannelEnum.GRABPAY
          },
          {
            label: intl.formatMessage(messages.paymaya),
            value: paymentChannelEnum.PAYMAYA
          }
        ]
      ),
      active: opts.paymentMethodType.active
    },
    {
      ...createTextField(
        PaymentEventsFilterKeys.reference,
        intl.formatMessage(messages.reference),
        opts.reference.value
      ),
      active: opts.reference.active
    }
  ];
}
